import React, { useState, useEffect } from "react";
import { useEtatGlobal } from "../../EtatGlobal.js";

import {
  Building2,
  AlertCircle,
  UserCheck,
  Loader2,
  Check,
  Users,
} from "lucide-react";
import { authFetch, httpClient } from '../../../HttpClient';

import { dialog } from "../../../components/ui/Dialog";
import { showSuccessToast } from "../../../components/ui/Toast";
import { normalizeText } from "../../../utils/text.js";
// prefill (depuis Mails.jsx, bouton "En mission ponctuelle") : { clientId,
// nomClient, commentaire } — pré-rempli à l'ouverture, reste modifiable.
const ModifSct = ({ onCancel, prefill }) => {
  const { setJuridiquePonctuelleData, fetchJuridiquePonctuelle } =
    useEtatGlobal();
  const [searchClient, setSearchClient] = useState(() => prefill?.nomClient || "");
  const [clientSuggestions, setClientSuggestions] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [clientError, setClientError] = useState("");

  const [allUsers, setAllUsers] = useState([]);
  const [searchUser, setSearchUser] = useState("");
  const [userSuggestions, setUserSuggestions] = useState([]);
  const [notifiedUserIds, setNotifiedUserIds] = useState([]);

  useEffect(() => {
    httpClient.get("https://backend-myalfa.vercel.app/api/users")
      .then(({ data }) => setAllUsers(data))
      .catch(() => {});
  }, []);

  const handleSearchUser = (e) => {
    const q = e.target.value;
    setSearchUser(q);
    if (q.length < 1) { setUserSuggestions([]); return; }
    setUserSuggestions(
      allUsers.filter((u) =>
        normalizeText(`${u.name} ${u.lastName}`).includes(normalizeText(q)) &&
        !notifiedUserIds.includes(u.id)
      ).slice(0, 8)
    );
  };

  const selectUser = (user) => {
    setNotifiedUserIds((prev) => [...prev, user.id]);
    setSearchUser("");
    setUserSuggestions([]);
  };

  const removeUser = (id) => setNotifiedUserIds((prev) => prev.filter((i) => i !== id));

  const [formData, setFormData] = useState(() => ({
    clientId: prefill?.clientId ? String(prefill.clientId) : "",
    activeForme: false,
    nouvelleFormeSociale: "",
    commentaireForme: "",
    activeSiege: false,
    adresseNouveauSiege: "",
    commentaireSiege: "",
    activeDateCloture: false,
    nouvelleDateCloture: "",
    commentaireDate: "",
    activeDenomination: false,
    nouvelleDenomination: "",
    commentaireDenomination: "",
    activeObjetSocial: false,
    modificationObjet: "",
    nouvellesActivites: "",
    commentaireObjet: "",
    activeCapital: false,
    nouveauCapital: "",
    commentaireCapital: "",
    activeDirigeant: false,
    typeModificationDirigeant: "",
    commentaireDirigeant: "",
    nature: "Juridique",
    dueDate: "",
    priority: "classique",
    status: "En attente",
    coefficient: "",
    todoCommentaire: prefill?.commentaire || "",
  }));

  console.log("Form Data:", formData);

  const handleChange = (e) => {
    const { name, type, checked, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.clientId) {
      dialog.alert("Veuillez saisir le clientId");
      return;
    }
    if (isSubmitting) return;
    setIsSubmitting(true);

    const { nature, dueDate, priority, todoCommentaire, ...modifFields } =
      formData;

    // UI instantanée : la mission apparaît tout de suite dans le tableau
    // Suivi Juridique Ponctuel, l'overlay se ferme, les appels partent en fond
    const details = [];
    if (formData.activeForme) details.push("Forme Sociale");
    if (formData.activeSiege) details.push("Siège");
    if (formData.activeDateCloture) details.push("Date Clôture");
    if (formData.activeDenomination) details.push("Dénomination");
    if (formData.activeObjetSocial) details.push("Objet Social");
    if (formData.activeCapital) details.push("Capital");
    if (formData.activeDirigeant) details.push("Dirigeant");

    const tempId = `temp-${Date.now()}`;
    const optimisticItem = {
      id: tempId,
      source: "modifsct",
      missionLabel: "Modification de Société",
      descriptif: details.join(" / ") || "-",
      clientId: Number(formData.clientId),
      client: { id: Number(formData.clientId), nom: searchClient },
      activeForme: formData.activeForme,
      activeSiege: formData.activeSiege,
      activeDateCloture: formData.activeDateCloture,
      activeDenomination: formData.activeDenomination,
      activeObjetSocial: formData.activeObjetSocial,
      activeCapital: formData.activeCapital,
      activeDirigeant: formData.activeDirigeant,
      commentaire: formData.todoCommentaire,
      dueDate: formData.dueDate
        ? new Date(formData.dueDate).toISOString()
        : null,
      priority: formData.priority,
      status: formData.status,
      coefficient: formData.coefficient || null,
      createdAt: new Date().toISOString(),
      Commentaire: [],
      Historique: [],
    };
    setJuridiquePonctuelleData((prev) => [...prev, optimisticItem]);
    onCancel?.();
    showSuccessToast(
      "Mission Modification de société créée",
      "Vous la retrouverez dans le tableau Suivi Juridique Ponctuel."
    );

    try {
      const modifPayload = {
        ...modifFields,
        clientId: Number(formData.clientId),
        nouvelleFormeSociale: formData.activeForme
          ? formData.nouvelleFormeSociale
          : null,
        commentaireForme: formData.activeForme
          ? formData.commentaireForme
          : null,
        adresseNouveauSiege: formData.activeSiege
          ? formData.adresseNouveauSiege
          : null,
        commentaireSiege: formData.activeSiege
          ? formData.commentaireSiege
          : null,
        nouvelleDateCloture: formData.activeDateCloture
          ? new Date(formData.nouvelleDateCloture).toISOString()
          : null,
        commentaireDate: formData.activeDateCloture
          ? formData.commentaireDate
          : null,
        nouvelleDenomination: formData.activeDenomination
          ? formData.nouvelleDenomination
          : null,
        commentaireDenomination: formData.activeDenomination
          ? formData.commentaireDenomination
          : null,
        modificationObjet: formData.activeObjetSocial
          ? formData.modificationObjet
          : null,
        nouvellesActivites: formData.activeObjetSocial
          ? formData.nouvellesActivites
          : null,
        commentaireObjet: formData.activeObjetSocial
          ? formData.commentaireObjet
          : null,
        nouveauCapital: formData.activeCapital ? formData.nouveauCapital : null,
        commentaireCapital: formData.activeCapital
          ? formData.commentaireCapital
          : null,
        typeModificationDirigeant: formData.activeDirigeant
          ? formData.typeModificationDirigeant
          : null,
        commentaireDirigeant: formData.activeDirigeant
          ? formData.commentaireDirigeant
          : null,
        dueDate: formData.dueDate,
        priority: formData.priority,
        status: formData.status,
        coefficient: formData.coefficient,
        commentaire: formData.todoCommentaire,
      };

      // Puis dans votre fetch :
      const res = await authFetch("https://backend-myalfa.vercel.app/api/modifsct",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(modifPayload),
        }
      );

      if (!res.ok) {
        throw new Error("Erreur lors de l'enregistrement");
      }

      // Remplace l'élément provisoire par l'enregistrement réel
      const created = await res.json().catch(() => null);
      if (created?.id) {
        setJuridiquePonctuelleData((prev) =>
          prev.map((item) =>
            item.id === tempId && item.source === "modifsct"
              ? { ...optimisticItem, ...created }
              : item
          )
        );
      }

      try {
        await authFetch("https://backend-myalfa.vercel.app/api/historique-client", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            titre: "Mission de modification de société",
            description: formData.todoCommentaire || "Modification de société",
            clientId: Number(formData.clientId),
          }),
        });
        console.log("Historique client créé avec succès !");
      } catch (histError) {
        console.error(
          "Erreur lors de la création de l'historique client :",
          histError
        );
      }

      // 2. Récupération des infos du client pour l'email (non bloquant)
      const clientRes = await authFetch(`https://backend-myalfa.vercel.app/api/clients/${formData.clientId}`
      );
      const clientData = clientRes.ok
        ? await clientRes.json()
        : { nom: searchClient };

      const userEmails = allUsers
        .filter((u) => notifiedUserIds.includes(u.id))
        .map((u) => u.email)
        .filter(Boolean);

      const emailPayload = {
        ...formData,
        nomClient: clientData.nom,
        userEmails,
      };

      try {
        await authFetch("https://backend-myalfa.vercel.app/api/email-modif-societe",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(emailPayload),
          }
        );
        console.log("Email de modification de société envoyé !");
      } catch (emailError) {
        console.error("Erreur lors de l'envoi de l'email :", emailError);
      }

      // const todoPayload = {
      //   title: "Modification de Société",
      //   status: "En cours",
      //   type: "MissionModifSoc",
      //   nomClient: clientData.nom,
      //   clientId: clientData.id,
      //   userIds: [36, 37],
      //   nature: formData.nature,
      //   dueDate: formData.dueDate
      //     ? new Date(formData.dueDate).toISOString()
      //     : null,
      //   priority: formData.priority,
      //   commentaire: formData.todoCommentaire,
      // };

      // // 5. Création du ToDo
      // const todoRes = await fetch(
      //   "https://backend-myalfa.vercel.app/api/todos",
      //   {
      //     method: "POST",
      //     headers: { "Content-Type": "application/json" },
      //     body: JSON.stringify(todoPayload),
      //   }
      // );
      // if (!todoRes.ok) {
      //   dialog.alert(
      //     "Droit social enregistré, mais erreur lors de la création du todo."
      //   );
      // }

      // 6. Reset du formulaire
      setFormData({
        clientId: "",
        activeForme: false,
        nouvelleFormeSociale: "",
        commentaireForme: "",
        activeSiege: false,
        adresseNouveauSiege: "",
        commentaireSiege: "",
        activeDateCloture: false,
        nouvelleDateCloture: "",
        commentaireDate: "",
        activeDenomination: false,
        nouvelleDenomination: "",
        commentaireDenomination: "",
        activeObjetSocial: false,
        modificationObjet: "",
        nouvellesActivites: "",
        commentaireObjet: "",
        activeCapital: false,
        nouveauCapital: "",
        commentaireCapital: "",
        activeDirigeant: false,
        typeModificationDirigeant: "",
        commentaireDirigeant: "",
        nature: "Juridique",
        dueDate: "",
        priority: "classique",
        status: "En attente",
        coefficient: "",
        todoCommentaire: "",
      });
      setSearchClient("");
      setNotifiedUserIds([]);
      setSearchUser("");

      // Resynchronise uniquement le Suivi Juridique Ponctuel (plus léger que fetchAll)
      fetchJuridiquePonctuelle();
    } catch (error) {
      console.error(error);
      // Échec : on retire la mission provisoire du tableau
      setJuridiquePonctuelleData((prev) =>
        prev.filter(
          (item) => !(item.id === tempId && item.source === "modifsct")
        )
      );
      dialog.alert(
        "Erreur lors de la création de la mission Modification de société."
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleSearchClient = async (e) => {
    const query = e.target.value;
    setSearchClient(query);

    // Dès qu'on tape quelque chose, on réinitialise le clientId
    setFormData((prev) => ({ ...prev, clientId: "" }));

    // Vérification clientId pour afficher l'erreur
    if (query !== "") {
      setClientError(
        "Veuillez sélectionner un client existant. Si le client n'existe pas, veuillez le créer ou faire une demande car cela va créer une erreur."
      );
    } else {
      setClientError("");
    }

    if (query.length < 2) {
      setClientSuggestions([]);
      return;
    }

    try {
      const res = await authFetch(`https://backend-myalfa.vercel.app/api/clients/search?search=${encodeURIComponent(
          query
        )}`
      );
      const data = await res.json();
      setClientSuggestions(data);
    } catch (error) {
      console.error("Erreur de recherche client :", error);
      setClientSuggestions([]);
    }
  };

  const selectClient = (client) => {
    setFormData((prev) => ({
      ...prev,
      clientId: client.id.toString(),
    }));
    setSearchClient(client.nom);
    setClientSuggestions([]);
    setClientError(""); // <-- On efface l'erreur ici
  };

  const isFormInvalid = !formData.clientId;

  return (
    <div className="flex flex-col h-full">
      <form onSubmit={handleSubmit} className="flex flex-col flex-1 min-h-0">
      <div className="flex-1 min-h-0 overflow-y-auto px-6 py-4">
      <div className="flex items-center gap-3 pb-3 border-b mt-5">
        <div className="w-8 h-8 rounded-lg bg-emerald-100 flex items-center justify-center">
          <Building2 className="w-4 h-4 text-emerald-600" />
        </div>
        <h3
          className="text-lg font-semibold text-slate-900 leading-none"
          style={{ margin: 0 }}
        >
          Modification de Société
        </h3>
      </div>
        <br />

        <div className="bg-gradient-to-br from-[#9B1B5D]/5 via-white to-transparent rounded-xl p-5 border-2 border-[#9B1B5D]/20">
          {/* Titre */}
          <h4 className="text-sm font-bold text-[#9B1B5D] mb-4 flex items-center gap-2">
            <AlertCircle className="w-4 h-4" />
            Informations essentielles
          </h4>
          <div className="space-y-4">
            <div>
              <label className="text-sm font-semibold flex items-center gap-2 text-slate-700">
                <UserCheck className="w-4 h-4 text-slate-500" />
                Client <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                value={searchClient}
                onChange={handleSearchClient}
                autoComplete="off"
                className={`
                  mt-2
                  w-full
                  h-11
                  rounded-md
                  bg-white
                  px-3
                  text-sm
                  outline-none
                  transition-all
                  border-2
                  ${
                    clientError
                      ? "border-red-400 focus:border-red-500"
                      : "border-slate-300 focus:border-emerald-400"
                  }
                `}
                placeholder="Sélectionner un client ou lead..."
              />

              {/* Suggestions */}
              {clientSuggestions.length > 0 && (
                <ul className="mt-1 max-h-60 overflow-y-auto rounded-md border border-slate-200 bg-white shadow-lg">
                  {clientSuggestions.map((client) => (
                    <li
                      key={client.id}
                      onClick={() => selectClient(client)}
                      className="
                      cursor-pointer
                      px-3
                      py-2
                      text-sm
                      text-slate-700
                      hover:bg-slate-100
                      transition-colors
                      border-b last:border-b-0
                    "
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.backgroundColor = "#f0f0f0")
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.backgroundColor = "white")
                      }
                    >
                      {client.nom}
                    </li>
                  ))}
                </ul>
              )}
            </div>
            {clientError && (
              <div style={{ color: "red", fontSize: "12px" }}>
                {clientError}
              </div>
            )}
            <div>
              <label>
                <input
                  type="checkbox"
                  name="activeForme"
                  checked={formData.activeForme}
                  onChange={handleChange}
                />{" "}
                Modifier Forme Sociale
              </label>
              {formData.activeForme && (
                <div className="grid grid-cols-2 gap-4 mt-3">
                  <input
                    className={`
                mt-2
                h-11
                w-full
                rounded-md
                bg-white
                px-3
                text-sm
                border-2
                outline-none
                transition-all
                ${
                  formData.nouvelleFormeSociale
                    ? "border-emerald-300 focus:border-emerald-400"
                    : "border-slate-300 focus:border-slate-400"
                }
              `}
                    type="text"
                    name="nouvelleFormeSociale"
                    placeholder="Nouvelle Forme Sociale"
                    value={formData.nouvelleFormeSociale}
                    onChange={handleChange}
                  />

                  <input
                    className={`
                mt-2
                h-11
                w-full
                rounded-md
                bg-white
                px-3
                text-sm
                border-2
                outline-none
                transition-all
                ${
                  formData.commentaireForme
                    ? "border-emerald-300 focus:border-emerald-400"
                    : "border-slate-300 focus:border-slate-400"
                }
              `}
                    type="text"
                    name="commentaireForme"
                    placeholder="Commentaire"
                    value={formData.commentaireForme}
                    onChange={handleChange}
                  />
                </div>
              )}
            </div>

            {/* Siege */}
            <div>
              <label>
                <input
                  type="checkbox"
                  name="activeSiege"
                  checked={formData.activeSiege}
                  onChange={handleChange}
                />{" "}
                Modifier Siege
              </label>
              {formData.activeSiege && (
                <div className="grid grid-cols-2 gap-4 mt-3">
                  <input
                    className={`
        mt-2
        h-11
        w-full
        rounded-md
        bg-white
        px-3
        text-sm
        border-2
        outline-none
        transition-all
        ${
          formData.adresseNouveauSiege
            ? "border-emerald-300 focus:border-emerald-400"
            : "border-slate-300 focus:border-slate-400"
        }
      `}
                    type="text"
                    name="adresseNouveauSiege"
                    placeholder="Adresse Nouveau Siege"
                    value={formData.adresseNouveauSiege}
                    onChange={handleChange}
                  />

                  <input
                    className={`
        mt-2
        h-11
        w-full
        rounded-md
        bg-white
        px-3
        text-sm
        border-2
        outline-none
        transition-all
        ${
          formData.commentaireSiege
            ? "border-emerald-300 focus:border-emerald-400"
            : "border-slate-300 focus:border-slate-400"
        }
      `}
                    type="text"
                    name="commentaireSiege"
                    placeholder="Commentaire"
                    value={formData.commentaireSiege}
                    onChange={handleChange}
                  />
                </div>
              )}
            </div>

            {/* Date de clôture */}
            <div>
              <label>
                <input
                  type="checkbox"
                  name="activeDateCloture"
                  checked={formData.activeDateCloture}
                  onChange={handleChange}
                />{" "}
                Modifier Date de Clôture
              </label>
              {formData.activeDateCloture && (
                <div className="grid grid-cols-2 gap-4 mt-3">
                  <input
                    className={`
        mt-2
        h-11
        w-full
        rounded-md
        bg-white
        px-3
        text-sm
        border-2
        outline-none
        transition-all
        ${
          formData.nouvelleDateCloture
            ? "border-emerald-300 focus:border-emerald-400"
            : "border-slate-300 focus:border-slate-400"
        }
      `}
                    type="date"
                    name="nouvelleDateCloture"
                    placeholder="Nouvelle Date de Clôture"
                    value={formData.nouvelleDateCloture}
                    onChange={handleChange}
                  />

                  <input
                    className={`
        mt-2
        h-11
        w-full
        rounded-md
        bg-white
        px-3
        text-sm
        border-2
        outline-none
        transition-all
        ${
          formData.commentaireDate
            ? "border-emerald-300 focus:border-emerald-400"
            : "border-slate-300 focus:border-slate-400"
        }
      `}
                    type="text"
                    name="commentaireDate"
                    placeholder="Commentaire"
                    value={formData.commentaireDate}
                    onChange={handleChange}
                  />
                </div>
              )}
            </div>

            {/* Dénomination */}
            <div>
              <label>
                <input
                  type="checkbox"
                  name="activeDenomination"
                  checked={formData.activeDenomination}
                  onChange={handleChange}
                />{" "}
                Modifier Dénomination
              </label>
              {formData.activeDenomination && (
                <div className="grid grid-cols-2 gap-4 mt-3">
                  <input
                    className={`
        mt-2
        h-11
        w-full
        rounded-md
        bg-white
        px-3
        text-sm
        border-2
        outline-none
        transition-all
        ${
          formData.nouvelleDenomination
            ? "border-emerald-300 focus:border-emerald-400"
            : "border-slate-300 focus:border-slate-400"
        }
      `}
                    type="text"
                    name="nouvelleDenomination"
                    placeholder="Nouvelle Dénomination"
                    value={formData.nouvelleDenomination}
                    onChange={handleChange}
                  />

                  <input
                    className={`
        mt-2
        h-11
        w-full
        rounded-md
        bg-white
        px-3
        text-sm
        border-2
        outline-none
        transition-all
        ${
          formData.commentaireDenomination
            ? "border-emerald-300 focus:border-emerald-400"
            : "border-slate-300 focus:border-slate-400"
        }
      `}
                    type="text"
                    name="commentaireDenomination"
                    placeholder="Commentaire"
                    value={formData.commentaireDenomination}
                    onChange={handleChange}
                  />
                </div>
              )}
            </div>

            {/* Objet Social */}
            <div>
              <label>
                <input
                  type="checkbox"
                  name="activeObjetSocial"
                  checked={formData.activeObjetSocial}
                  onChange={handleChange}
                />{" "}
                Modifier Objet Social
              </label>
              {formData.activeObjetSocial && (
                <div className="grid grid-cols-2 gap-4 mt-3">
                  <input
                    className={`
        mt-2
        h-11
        w-full
        rounded-md
        bg-white
        px-3
        text-sm
        border-2
        outline-none
        transition-all
        ${
          formData.modificationObjet
            ? "border-emerald-300 focus:border-emerald-400"
            : "border-slate-300 focus:border-slate-400"
        }
      `}
                    type="text"
                    name="modificationObjet"
                    placeholder="Modification Objet"
                    value={formData.modificationObjet}
                    onChange={handleChange}
                  />

                  <input
                    className={`
        mt-2
        h-11
        w-full
        rounded-md
        bg-white
        px-3
        text-sm
        border-2
        outline-none
        transition-all
        ${
          formData.nouvellesActivites
            ? "border-emerald-300 focus:border-emerald-400"
            : "border-slate-300 focus:border-slate-400"
        }
      `}
                    type="text"
                    name="nouvellesActivites"
                    placeholder="Nouvelles Activités"
                    value={formData.nouvellesActivites}
                    onChange={handleChange}
                  />

                  <input
                    className={`
        mt-2
        h-11
        w-full
        rounded-md
        bg-white
        px-3
        text-sm
        border-2
        outline-none
        transition-all
        ${
          formData.commentaireObjet
            ? "border-emerald-300 focus:border-emerald-400"
            : "border-slate-300 focus:border-slate-400"
        }
      `}
                    type="text"
                    name="commentaireObjet"
                    placeholder="Commentaire"
                    value={formData.commentaireObjet}
                    onChange={handleChange}
                  />
                </div>
              )}
            </div>

            {/* Capital */}
            <div>
              <label>
                <input
                  type="checkbox"
                  name="activeCapital"
                  checked={formData.activeCapital}
                  onChange={handleChange}
                />{" "}
                Modifier Capital
              </label>
              {formData.activeCapital && (
                <div className="grid grid-cols-2 gap-4 mt-3">
                  <input
                    className={`
        mt-2
        h-11
        w-full
        rounded-md
        bg-white
        px-3
        text-sm
        border-2
        outline-none
        transition-all
        ${
          formData.nouveauCapital
            ? "border-emerald-300 focus:border-emerald-400"
            : "border-slate-300 focus:border-slate-400"
        }
      `}
                    type="text"
                    name="nouveauCapital"
                    placeholder="Nouveau Capital"
                    value={formData.nouveauCapital}
                    onChange={handleChange}
                  />

                  <input
                    className={`
        mt-2
        h-11
        w-full
        rounded-md
        bg-white
        px-3
        text-sm
        border-2
        outline-none
        transition-all
        ${
          formData.commentaireCapital
            ? "border-emerald-300 focus:border-emerald-400"
            : "border-slate-300 focus:border-slate-400"
        }
      `}
                    type="text"
                    name="commentaireCapital"
                    placeholder="Commentaire"
                    value={formData.commentaireCapital}
                    onChange={handleChange}
                  />
                </div>
              )}
            </div>

            {/* Dirigeant */}
            <div>
              <label>
                <input
                  type="checkbox"
                  name="activeDirigeant"
                  checked={formData.activeDirigeant}
                  onChange={handleChange}
                />{" "}
                Modifier Dirigeant
              </label>
              {formData.activeDirigeant && (
                <div className="grid grid-cols-2 gap-4 mt-3">
                  <input
                    className={`
        mt-2
        h-11
        w-full
        rounded-md
        bg-white
        px-3
        text-sm
        border-2
        outline-none
        transition-all
        ${
          formData.typeModificationDirigeant
            ? "border-emerald-300 focus:border-emerald-400"
            : "border-slate-300 focus:border-slate-400"
        }
      `}
                    type="text"
                    name="typeModificationDirigeant"
                    placeholder="Type de Modification Dirigeant"
                    value={formData.typeModificationDirigeant}
                    onChange={handleChange}
                  />

                  <input
                    className={`
        mt-2
        h-11
        w-full
        rounded-md
        bg-white
        px-3
        text-sm
        border-2
        outline-none
        transition-all
        ${
          formData.commentaireDirigeant
            ? "border-emerald-300 focus:border-emerald-400"
            : "border-slate-300 focus:border-slate-400"
        }
      `}
                    type="text"
                    name="commentaireDirigeant"
                    placeholder="Commentaire"
                    value={formData.commentaireDirigeant}
                    onChange={handleChange}
                  />
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="grid grid-cols-4 gap-3 mt-5">
          <div>
            <label className="text-sm font-semibold text-slate-700 flex items-center gap-1">
              Echéance{" "}
            </label>
            <input
              name="dueDate"
              type="date"
              value={formData.dueDate}
              onChange={handleChange}
              className={`
                mt-2
                h-11
                w-full
                rounded-md
                bg-white
                px-3
                text-sm
                border-2
                outline-none
                transition-all
                ${
                  formData.dueDate
                    ? "border-emerald-300 focus:border-emerald-400"
                    : "border-slate-300 focus:border-slate-400"
                }
              `}
            />
          </div>
          <div>
            <label className="text-sm font-semibold text-slate-700 flex items-center gap-1">
              Priorité
            </label>
            <select
              name="priority"
              value={formData.priority}
              onChange={handleChange}
              className={`
                mt-2
                h-11
                w-full
                rounded-md
                bg-white
                px-3
                text-sm
                border-2
                outline-none
                transition-all
                ${
                  formData.priority
                    ? "border-emerald-300 focus:border-emerald-400"
                    : "border-slate-300 focus:border-slate-400"
                }
              `}
            >
              <option value="classique">Classique</option>
              <option value="élevé">Élevé</option>
            </select>
          </div>
          <div>
            <label className="text-sm font-semibold text-slate-700 flex items-center gap-1">
              Status
            </label>
            <select
              name="status"
              value={formData.status}
              onChange={handleChange}
              className={`
                mt-2
                h-11
                w-full
                rounded-md
                bg-white
                px-3
                text-sm
                border-2
                outline-none
                transition-all
                ${
                  formData.status
                    ? "border-emerald-300 focus:border-emerald-400"
                    : "border-slate-300 focus:border-slate-400"
                }
              `}
            >
              <option value="En attente">En attente</option>
              <option value="En attente informations / documents">
                En attente informations / documents
              </option>
              <option value="En attente interne">En attente interne</option>
              <option value="Dépôt de capital en cours">
                Dépôt de capital en cours
              </option>
              <option value="Rédaction">Rédaction</option>
              <option value="Supervision">Supervision</option>
              <option value="Signature">Signature</option>
              <option value="Signature en cours">Signature en cours</option>
              <option value="Formalité">Formalité</option>
              <option value="Formalité déposée">Formalité déposée</option>
              <option value="Formalité à régulariser">
                Formalité à régulariser
              </option>
              <option value="Formalité rejetée">Formalité rejetée</option>
              <option value="Bloqué">Bloqué</option>
              <option value="Abandonné">Abandonné</option>
              <option value="Terminé">Terminé</option>
            </select>
          </div>
          <div>
            <label className="text-sm font-semibold text-slate-700 flex items-center gap-1">
              Coefficient
            </label>
            <input
              name="coefficient"
              type="text"
              value={formData.coefficient}
              onChange={handleChange}
              className={`
                mt-2
                h-11
                w-full
                rounded-md
                bg-white
                px-3
                text-sm
                border-2
                outline-none
                transition-all
                ${
                  formData.coefficient
                    ? "border-emerald-300 focus:border-emerald-400"
                    : "border-slate-300 focus:border-slate-400"
                }
              `}
            />
          </div>
        </div>
        <div className="mt-4">
          <label className="text-sm font-medium text-slate-700 mb-1 block">
            Commentaire :
          </label>
          <textarea
            name="todoCommentaire"
            rows={4}
            value={formData.todoCommentaire}
            onChange={handleChange}
            placeholder="Précisions..."
            className="w-full rounded-md border-2 border-slate-300 px-3 py-2 text-sm bg-white outline-none focus:border-emerald-400 transition-all"
          />
        </div>
        {/* Collaborateurs à notifier */}
        <div className="mt-5 rounded-xl border border-slate-200 bg-slate-50 p-4">
          <label className="text-sm font-semibold flex items-center gap-2 text-slate-700 mb-3">
            <Users className="w-4 h-4 text-slate-500" />
            Collaborateurs à notifier par email
          </label>
          <div className="relative">
            <input
              type="text"
              value={searchUser}
              onChange={handleSearchUser}
              placeholder="Rechercher un collaborateur…"
              autoComplete="off"
              className="w-full h-10 rounded-md bg-white px-3 text-sm border-2 border-slate-300 focus:border-emerald-400 outline-none transition-all"
            />
            {userSuggestions.length > 0 && (
              <ul className="absolute left-0 top-full mt-1 w-full max-h-48 overflow-y-auto rounded-md border border-slate-200 bg-white shadow-lg z-20">
                {userSuggestions.map((user) => (
                  <li
                    key={user.id}
                    onClick={() => selectUser(user)}
                    className="cursor-pointer px-3 py-2 text-sm text-slate-700 hover:bg-slate-100 transition-colors border-b last:border-b-0"
                  >
                    {user.name} {user.lastName}
                  </li>
                ))}
              </ul>
            )}
          </div>
          <div className="mt-3 flex flex-wrap gap-2">
            {notifiedUserIds.length === 0 ? (
              <p className="text-sm text-slate-400 italic">Aucun collaborateur sélectionné.</p>
            ) : (
              notifiedUserIds.map((id) => {
                const user = allUsers.find((u) => u.id === id);
                return (
                  <div key={id} className="flex items-center gap-2 bg-emerald-50 border border-emerald-200 text-emerald-700 px-3 py-1.5 rounded-full text-sm">
                    <span>{user?.name || "?"} {user?.lastName || ""}</span>
                    <button type="button" onClick={() => removeUser(id)} className="text-emerald-600 hover:text-red-500 font-medium transition-colors">✕</button>
                  </div>
                );
              })
            )}
          </div>
        </div>

      </div>
      <div className="shrink-0 bg-white border-t px-8 py-4 flex items-center justify-between">
          <button
            type="button"
            variant="outline"
            onClick={onCancel}
            className={`
              px-8
              h-11
              border-2
              border-slate-300
              text-slate-700
              rounded-md
              font-medium
              hover:bg-slate-100
              transition-colors
            `}
          >
            Annuler
          </button>
          <button
            type="submit"
            disabled={isSubmitting || isFormInvalid}
            className={`
w-1/2
h-11
${
  isSubmitting || isFormInvalid
    ? "bg-gray-400 cursor-not-allowed"
    : "bg-[#9B1B5D] hover:bg-[#7A1548]"
}
text-white
text-base
font-medium
rounded-md
shadow-lg shadow-[#9B1B5D]/20
transition-colors
flex items-center justify-center
gap-2
`}
          >
            {isSubmitting ? (
              <>
                <Loader2 className="w-5 h-5 mr-2 animate-spin" />
                Création en cours...
              </>
            ) : (
              <>
                <Check className="w-5 h-5 mr-2" />
                Créer la mission
              </>
            )}
          </button>
        </div>
    </form>
  </div>
  );
};

export default ModifSct;
